import { useState, useEffect } from "react";
import { Toast } from "../Toast/Toast";
import "./Contact.css";

const successMessage = "Your query has been submitted successfully. You can expect a response within 24-48 hours. For faster assistance, please feel free to call us directly.";
const errorMessage = "Our contact form is temporarily unavailable. Kindly call us directly at the phone number listed for assistance";
const cloudFlareSiteKey = "0x4AAAAAACdO-xslJhBojF8T";

const Contact = () => {
    const [, setResult] = useState("");
    const [toast, setToast] = useState(null);
    const [verified, setVerified] = useState(false);

    // useEffect(() => {
    //     if (window.turnstile) {
    //       window.turnstile.render("#turnstile", {
    //         sitekey: cloudFlareSiteKey,
    //         callback: function (token) {
    //             console.log("Success:", token);
    //         },
    //       });
          
    //     }
    //   }, []);

    const showToast = (type, message) => {
        setToast({
          type,
          message
        });
    };

    const isFormDataValid = (formData) => {
        // check email 
        if (!formData.get('name')) {
            showToast("error", "Please enter your name.");
            return false;
        } else if (!formData.get('email') || !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.get('email')))) {
            showToast("error", "Please enter valid email address.");
            return false;
        } else if (!formData.get('tel') || !(/^(\+91[\-\s]?|91[\-\s]?|0)?[6-9]\d{9}$/.test(formData.get('tel')))) {
            showToast("error", "Please enter valid phone number.");
            return false;
        } else if (!formData.get('requirement')) {
            showToast("error", "Please enter your requirements.");
            return false;
        }
        return true;
    }

    const submitQuery = async (event) =>  {
        event.preventDefault();
        const formData = new FormData(event.target);
        // if (!verified) {
        //     showToast("Please verify that you are not a robot");
        //     return;
        // }

        if (!isFormDataValid(formData)) {
            return 
        }

        formData.append("access_key", "1efbfd9f-fd61-4ab5-b25e-a9d4d4ca5c02");
    
        const response = await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          body: formData
        });
    
        const data = await response.json();
        data.success ? 
            showToast("success", successMessage) : 
            showToast("error", errorMessage);

        setResult(data.success ? "Success!" : "Error!");
    };


    return (
        <section className="contact" id="contact">
             {toast && (
                <Toast
                type={toast.type}
                message={toast.message}
                onClose={() => setToast(null)}
                />
            )}
            <div className="contact-container">

                {/* Left Section */}
                <div className="contact-info">
                    <h2>Let's Design Your Dream Home</h2>
                    <p>
                        Get in touch with us for a free consultation. We’d love to
                        understand your space and bring your vision to life.
                    </p>

                    <div className="info-block">
                        <span>📍</span>
                        <p>Bangalore, India</p>
                    </div>

                    <div className="info-block">
                        <span>📞</span>
                        <p>+91 9769611279</p>
                    </div>

                    <div className="info-block">
                        <span>✉️</span>
                        <p>info@elevatespace.in</p>
                    </div>

                    <div className="contact-note">
                        We provide end-to-end interior solutions including modular kitchens,
                        wardrobes, TV units, and complete home interiors. 
                        <br /><br />
                        Expect response within 24-48 hours. We look forward to connecting with you!
                    </div>
                </div>

                {/* Right Section */}
                <div className="contact-form">
                    <h3>Request a Free Consultation</h3>

                    <form onSubmit={submitQuery}>
                        <input name="name" type="text" placeholder="Your Name" required />
                        <input name="email" type="email" placeholder="Email Address" required />
                        <input name="tel" type="tel" placeholder="Phone Number" required />
                        <textarea name="requirement" placeholder="Tell us about your home requirements" rows="4"></textarea>
                        {/* Turnstile */}
                        <div
                            id="turnstile"
                            className="cf-turnstile"
                            data-sitekey={cloudFlareSiteKey}
                            data-callback={() => setVerified(true)}
                        ></div>

                        <button type="submit">Submit</button>
                    </form>
                </div>

            </div>
        </section>
    );
}


export { Contact };